import { Button, Form } from 'react-bootstrap'

import styled from 'styled-components'

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
`

export const FormControl = styled(Form.Control)`
  color: black;
  &:hover,
  &:focus {
    color: black;
  }

  &::placeholder {
    color: #b1b1b1;
  }
`

export const CloseButton = styled(Button)`
  padding: 0;
  height: 32px;
  width: 32px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const spacer = (props) => ({
  margin: props.margin,
  marginTop: props.mt,
  marginRight: props.mr,
  marginBottom: props.mb,
  marginLeft: props.ml,
  padding: props.padding,
  paddingTop: props.pt,
  paddingRight: props.pr,
  paddingBottom: props.pb,
  paddingLeft: props.pl,
})

export const YStack = styled.div`
  display: flex;
  flex-direction: column;
  ${spacer}
`

export const XStack = styled.div`
  display: flex;
  align-items: center;
  ${spacer}
`
export const Title = styled.div``

export const Description = styled.div``

export const Td = styled.td`
  max-width: 150px;
`
